var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPureStorage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M39.3291,9.66455l-4,8A.75023.75023,0,0,0,36,18.75h6.78613l-3.457,6.91455,1.3418.6709,4-8A.75023.75023,0,0,0,44,17.25H37.21387l3.457-6.91455Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25,70a.7502.7502,0,0,0,.75.75H70a.7502.7502,0,0,0,.75-.75V58h-1.5V69.25H10.75V58H9.25Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25,52a.7502.7502,0,0,0,.75.75H70a.7502.7502,0,0,0,.75-.75V40h-1.5V51.25H10.75V40H9.25Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.25,22V34a.7502.7502,0,0,0,.75.75H70a.7502.7502,0,0,0,.75-.75V22h-1.5V33.25H10.75V22Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPureStorage);
export default __webpack_public_path__ + "static/media/icon_pure_storage.7ecfc5138b5cbb4d4982401333796a34.svg";
export { ForwardRef as ReactComponent };